// Produktet Travel tani ruhen në Supabase database
export const productsTravel = [];
